import React from 'react';

import { Card, Col, Row, Typography, ViewContainer } from 'components/AORedesign';
import featureFlags from '../../../constants/featureFlags';
import { ROUTE_REDESIGN_APP_ADMIN } from '../../../constants/routes';
import { Feature } from '../../Feature';
import { AddNewsArticle, EditNewsArticle } from '../NewsArticleAdministration/AddOrEditNewsArticle';

const NewsAdmin = () => {
  return (
    <Feature allowed={featureFlags.ACCESS_CONTENT_MGMT_ADMIN}>
      <ViewContainer
        title={'News Article Administration'}
        hidePolicyViewChange
        hideStartQuote
        returnRoute={{ text: 'Application Administration', route: ROUTE_REDESIGN_APP_ADMIN }}>
        <Card>
          <Row spacing={4}>
            <Col xs={4}>
              <Typography color="textSecondary">
                Welcome to the News Administration Home Page. The links to the right offer access to all of the resources you need to add or modify news
                articles on the Home page.
              </Typography>
            </Col>

            <Col xs={8}>
              <Row spacing={4}>
                <Col xs={12}>
                  <AddNewsArticle />
                  <Typography color="textSecondary">From this screen you may add new articles that will be available on the Home page.</Typography>
                </Col>

                <Col xs={12}>
                  <EditNewsArticle />
                  <Typography color="textSecondary">From this page you may edit, delete or hide existing articles available on the Home page.</Typography>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </ViewContainer>
    </Feature>
  );
};

export default NewsAdmin;
